import React from 'react'
import PropTypes from 'prop-types'
import {
  TooltipAnchor,
  FormattedNumber,
} from 'belle-js'
import styles from './EllevestBalance.module.scss'
import { trackAnalyticsEvent } from 'analytics'

const EllevestBalance = (props) => {
  const  {
    children,
    label
  } = props

  return  (
    <div className={styles.balanceContainer}>
      <div className={styles.ellevestLabel}>
        {label}
        <span className={styles.tooltip}>
          <TooltipAnchor
            onOpen={() => trackAnalyticsEvent('Portfolio Value Tooltip Clicked')}
            showToggleButton={true}
            enableHover={null}
            contentClassName={styles.contentWidth}>
            <div className={styles.tooltipContent}>
              <p>This is the total balance of your investments listed below.
              Accounts custodied at Schwab are updated daily.
              Alternative asset value is reviewed periodically
              and revised when material changes arise.
              </p>
            </div>
          </TooltipAnchor>
        </span>
      </div>
      <div data-test-id="ellevestBalance" className={styles.ellevestBalance}>
        <FormattedNumber
          value={children}
          format="currencyWithDecimal"
          showNegativeSign={false} />
      </div>
    </div>
  )
}

EllevestBalance.defaultProps = {
  children: <div />,
  label: 'Portfolio Value'
}

EllevestBalance.propTypes = {
  children: PropTypes.node,
  label: PropTypes.string
}

export default EllevestBalance



// WEBPACK FOOTER //
// ./src/components/Client/Header/EllevestBalance/EllevestBalance.jsx